import {GenericSidebarItemBadgeComponent} from '@/components/_domain/SidebarItemBadges/SidebarItemBadge';
import {ReactNode} from 'react';

export type BaseSidebarContentProps = {
  onClose?: () => void;
  children?: React.ReactNode;
};

export type SidebarCategory =
  | 'engagement'
  | 'communities'
  | 'payments'
  | 'concierge'
  | 'onboarding'
  | 'compliance'
  | 'bookings'
  | 'admin'
  | 'dashboard'
  | 'reporting'
  | 'conversations'
  | 'safetyCenter'
  | 'tasks';

export const SIDEBAR_CATEGORY_LABELS: Record<SidebarCategory, string> = {
  dashboard: 'Dashboard',
  reporting: 'Reporting',
  communities: 'Communities',
  conversations: 'Conversations',
  engagement: 'Engagement',
  bookings: 'Bookings',
  concierge: 'Concierge',
  tasks: 'Tasks',
  payments: 'Payments',
  compliance: 'Compliance',
  safetyCenter: 'Safety Center',
  admin: 'Admin',
  onboarding: 'Onboarding',
};

export type SidebarCategoryItemProps = {
  label: SidebarCategory;
  icon: ReactNode;
  url?: string;
  BadgeComponent?: GenericSidebarItemBadgeComponent;
};
